// Read-only ветка бывшего RichTextEditor, вынесена в отдельный компонент:
// @tiptap/react@3's useEditor строит Editor+EditorView eagerly, поэтому read-only
// рендер (например тумбнейлы таймлайна) не должен монтировать tiptap вовсе —
// иначе каждый текстовый элемент дизайн-блока в каждом тумбнейле собирает
// одноразовый редактор впустую.
import { useId, useMemo } from 'react'
import { cn } from '@teach/ui'
import { sanitizeDesignHtml } from '@/features/editor/lib/designHtml'
import {
  highlightScopeStyles,
  type HighlightTokens,
} from '@/features/editor/lib/designElementStyles'

interface Props {
  content: string
  highlight: HighlightTokens
  textSizeClassName?: string
  textAlignClassName?: string
  textColor?: string
}

export const RichTextView = ({
  content,
  highlight,
  textSizeClassName,
  textAlignClassName,
  textColor = 'inherit',
}: Props) => {
  const scope = `rte-${useId().replace(/:/g, '')}`
  // Каждый рендер (в т.ч. каждый тумбнейл таймлайна) иначе гонял бы полный проход
  // DOMPurify заново — мемоизация по самому content держит его один раз.
  const sanitized = useMemo(() => sanitizeDesignHtml(content), [content])

  // Санитизированный HTML идёт через sanitizeDesignHtml (аллоулист тегов/атрибутов
  // 1:1 с беком) — dangerouslySetInnerHTML здесь безопасен именно поэтому.
  return (
    <div
      className={cn(scope, 'w-full', textSizeClassName, textAlignClassName)}
      style={{ color: textColor }}
    >
      <style>{highlightScopeStyles(scope, highlight)}</style>
      <div dangerouslySetInnerHTML={{ __html: sanitized }} />
    </div>
  )
}
